import "./module/toggle"
import "./module/swiper-recruit"
import "./module/smooth"
import "./module/micromodal"
import "./module/scrollmagic"
import "./module/paralax"

const body = document.querySelector('body');
const loading = document.getElementById('loading');

window.onload = () => {
    setTimeout(() => {
        body.classList.add('loaded');
    }, 3000 );

    // sessionStorage.setItem('loading', 'on');
};

// if( sessionStorage.getItem('loading') ) {
//     loading.remove();
//     body.classList.add('loaded');
// }